module.exports = __webpack_public_path__ + "static/media/browse-stock-assets.46c2f32a.jpg";